(() => {
  if (customElements.get('rss-cart-extras')) return;
  customElements.define('rss-cart-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.hidden = false;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-extra-options]')) return;
        const card = event.target.closest('[data-cart-extra]');
        const template = [...card.querySelectorAll('[data-extra-variant-price]')].find(node => node.dataset.extraVariantPrice === event.target.value);
        if (template) card.querySelector('[data-extra-price]').replaceChildren(template.content.cloneNode(true));
        card.querySelector('[data-extra-add]').dataset.extraAdd = event.target.value;
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-extra-add]');
        if (button) this.add(button);
      });
    }
    async add(button) {
      if (this.busy) return;
      this.busy = true;
      const original = button.textContent;
      const status = this.querySelector('.rss-cart-extras-status');
      this.querySelectorAll('button, select').forEach(control => { control.disabled = true; });
      button.textContent = this.dataset.adding;
      status.hidden = true;
      const mini = document.querySelector('mini-cart');
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.extraAdd), quantity: 1 }], sections: mini.getSectionsToRender().map(section => section.section), sections_url: location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
        added = true;
        mini.renderContents(data);
        const cart = document.querySelector('cart-items');
        if (cart) await cart.updateSectionContents();
        const focus = cart ? document.querySelector('[name="checkout"]') : mini.querySelector('[name="checkout"]');
        focus?.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: data.items, context: 'BasketExtras' } }));
      } catch (error) {
        status.textContent = added ? this.dataset.added : error.message || this.dataset.error;
        status.hidden = false;
        if (added) {
          button.textContent = this.dataset.added;
          button.disabled = true;
          return;
        }
      } finally {
        this.busy = false;
        if (!added && this.isConnected) {
          this.querySelectorAll('button, select').forEach(control => { control.disabled = false; });
          button.textContent = original;
        }
      }
    }
  });
})();
